import { Veiculo } from "../enums/Veiculo";

export const VeiculoLabel = new Map<number, string>([
    [Veiculo.Onibus, "Ônibus"],
    [Veiculo.Van, "Van"],
    [Veiculo.MicroOnibus, "Micro Ônibus"],
  ]);
  